import { useQuery } from '@tanstack/react-query'
import useGetPeriodColumns from '../cash-flow/useGetPeriodColumns.js'
import useAppStore from '@/store/useAppStore'

export default function useGetPeriodByOffset({ offset, position } = {}) {
  const viewPeriodType = useAppStore((state) => state.periodType)
  const viewOffset = useAppStore((state) => state.offset)
  const viewNumberOfPeriods = useAppStore((state) => state.numberOfPeriods)

  const { promise } = useGetPeriodColumns({
    offset: viewOffset,
    numberOfPeriods: viewNumberOfPeriods,
    periodType: viewPeriodType,
  })

  const fetchData = async () => {
    const [data] = await Promise.all([promise]) //refetch({ cancelRefetch: false })

    if (position !== undefined) {
      return data[position]
    }

    const result = data.find((x) => x.offset === Number(offset))
    return result
  }

  return useQuery({
    queryKey: [
      'periods',
      'offset',
      { offset, viewNumberOfPeriods, viewPeriodType, viewOffset },
    ],
    queryFn: fetchData,
    enabled: !!offset,
  })
}
